import { stringify } from 'gradient-parser';

const roundTo = (value, precision) => {
  const factor = 10 ** precision;

  return Math.round(value * factor) / factor;
};

const mapColorStop = (stop) => {
  const [h, s, l, a] = stop.value.map(Number);
  const isTranslucent = a !== undefined && a !== 1;
  const hue = roundTo(h, 2);
  const saturation = roundTo(s * 100, 2);
  const lightness = roundTo(l * 100, 2);
  const alpha = roundTo(a, 3);

  return {
    type: isTranslucent ? 'hsla' : 'hsl',
    value: isTranslucent
      ? [String(hue), String(saturation), String(lightness), String(alpha)]
      : [String(hue), String(saturation), String(lightness)],
    length: stop.length,
  };
};

const stringifyGradientModel = (model) => {
  if (!model) return '';

  const gradientAST = [
    {
      type: model.type,
      orientation: model.orientation,
      colorStops: model.colorStops.map(mapColorStop),
    },
  ];

  return stringify(gradientAST);
};

export default stringifyGradientModel;
